module.exports = __webpack_public_path__ + "static/media/set.c53cdf87.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/set.gif
// module id = 347
// module chunks = 0